import {
  Box,
  Chip,
  IconButton,
  LinearProgress,
  linearProgressClasses,
  styled,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InsigniaMembresia from "../../../assets/images/temporalImages/GoldInsignia.png";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import ListPayments from "./ListPayment";
import ListCardsAction from "./ListCardsAction";
import ModalDetailsOfMembership from "./ModalDetailsOfMembership";
import Loading from "../../Loading/Loading";
import toast from "react-hot-toast";
import { handleError } from "../../../utils/handleError";
import ModalBenefitsOfMembership from "./ModalBenefitsOfMembership";
import ModalAlertStatusMembership from "../../ModalAlertStatusMembership/ModalAlertStatusMembership.";
import {
  getMembershipByUser,
  getMembershipByUserPS,
  getPaymentHistoryMembership,
  getPaymentHistoryMembershipPS,
} from "../../../services/rest/membership/membershipService";
import { setMembership } from "../../../redux/slice/membershipSlice";
import ModalSuccessPayment from "../Membership/ModalSuccessPayment";
import { useLocation } from "react-router-dom";
import { getMembershipStatus } from "../../../hooks/useMembershipExpiration";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.#e7ef7d`]: {
    backgroundColor: theme.palette.grey[200],
    ...theme.applyStyles("dark", {
      backgroundColor: theme.palette.grey[800],
    }),
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: "#e7ef7d",
    ...theme.applyStyles("dark", {
      backgroundColor: "#e7ef7d",
    }),
  },
}));
const UserAccount = () => {
  const { planName, membershipStatus, routeLimit } = useSelector(
    (state) => state.membershipReducer
  );
  const nowDate = new Date();
  const auxDate = nowDate.toISOString();
  const dispatch = useDispatch();
  const { totalOfRoutes } = useSelector((state) => state.routeReducer);
  const { status, userType, _id } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [listPayment, setListPayment] = useState([]);
  const [showModalBenefits, setSHowModalBenefits] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const location = useLocation();
  const paymentStatus = location.state?.paymentStatus;

  useEffect(() => {
    const getAllPaymentsAndStatusMembership = async () => {
      try {
        setLoading(true);
        let currentMembership;
        //Se obtendra todo el historial de pagos en caso de tener membresia activa
        if (userType === "user") {
          currentMembership = await getMembershipByUser({ userId: _id });
          // console.log("Ultmima membresia de User:", currentMembership);
          const listPayments = await getPaymentHistoryMembership({
            userId: _id,
          });
          // console.log("Listado de pagos", listPayments);
          setListPayment(listPayments ?? []);
        } else {
          currentMembership = await getMembershipByUserPS({ userId: _id });
          // console.log("Ultmima membresia de PS:", currentMembership);
          const listPayments = await getPaymentHistoryMembershipPS({
            userId: _id,
          });
          // console.log("Listado de pagos", listPayments);
          setListPayment(listPayments ?? []);
        }
        let status = { isExpired: true };

        if (
          currentMembership?.activeMemb?.membershipType &&
          currentMembership?.activeMemb?.membershipType !== "Free"
        ) {
          status = getMembershipStatus(
            currentMembership?.activeMemb?.expiresAt ?? auxDate
          );
        }

        dispatch(
          setMembership({
            _id: currentMembership?.activeMemb?._id ?? 0,
            planName: currentMembership?.activeMemb?.membershipType ?? "Free",
            price: currentMembership?.activeMemb?.amount ?? 0,
            currency: currentMembership?.activeMemb?.currency ?? "MXN",
            description: currentMembership?.description ?? [],
            routeLimit: currentMembership?.routeLimit ?? 0,
            membershipStatus: status?.isExpired ? "inactive" : "active",
            lastPayment: currentMembership?.activeMemb?.paymentDate ?? auxDate,
            nextPayment: currentMembership?.activeMemb?.expiresAt ?? auxDate,
          })
        );

        setLoading(false);
      } catch (error) {
        setLoading(false);
        const { message } = handleError(error);
        toast.error(`No se pudo ubtener la lista de pago. \n ${message}`);
      }
    };
    getAllPaymentsAndStatusMembership();
    paymentStatus && setShowModalSuccess(true);
  }, [membershipStatus, _id, showModalSuccess, paymentStatus]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <Loading loading={loading} />

      <ModalDetailsOfMembership
        open={open}
        setOpen={setOpen}
        setLoading={setLoading}
      />

      <ModalBenefitsOfMembership
        open={showModalBenefits}
        setOpen={setSHowModalBenefits}
      />
      <ModalSuccessPayment
        open={showModalSuccess}
        setOpen={setShowModalSuccess}
      />
      {!loading && status === "active" && !showModalSuccess && (
        <ModalAlertStatusMembership />
      )}
      <ListCardsAction
        setOpen={setOpen}
        setLoading={setLoading}
        setShowModalSuccess={setShowModalSuccess}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" }, // Columna en móviles, fila en desktop
          justifyContent: "space-around",
          gap: 4,
          paddingLeft: 4,
          paddingRight: 4,
          width: "100%", // Asegura que ocupe todo el ancho
        }}
      >
        {/* Primer Box (Información de membresía) */}
        <Box
          sx={{
            display: "flex",
            position: "relative",
            flexDirection: "column",
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            borderRadius: 5,
            padding: 4,
            gap: 4,
            width: { xs: "100%", md: "45%" }, // Ancho completo en móvil, 45% en desktop
            boxSizing: "border-box", // Para que el padding no afecte el ancho
          }}
        >
          <IconButton
            sx={{ position: "absolute", right: 20 }}
            onClick={() => setSHowModalBenefits(true)}
          >
            <RemoveRedEyeIcon />
          </IconButton>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              gap: 4,
              alignItems: "center",
            }}
          >
            <Box>
              <img
                src={InsigniaMembresia}
                alt="Insignia de membresi"
                width={200}
                style={{ maxWidth: "100%" }} // Para que la imagen sea responsiva
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography>Membresía</Typography>
              <Chip
                label={planName ?? "Free"}
                style={{
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }}
              />
              <Typography
                textAlign={"center"}
                sx={{ color: membershipStatus === "active" ? "green" : "red" }}
              >
                {membershipStatus === "active"
                  ? "Activa"
                  : membershipStatus === "inactive" && "Inactiva"}
              </Typography>
            </Box>
          </Box>
          {userType === "user" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                width: "100%",
              }}
            >
              <Typography textAlign={"center"}>{routeLimit} Rutas</Typography>
              <BorderLinearProgress
                variant="determinate"
                value={totalOfRoutes ? (totalOfRoutes / routeLimit) * 100 : 0}
              />
            </Box>
          )}
          {/* {membershipStatus === "active" && (
            <Box>
              <Typography textAlign={"center"} color="#e7ef7d">
                El pago de su membresía será automático.
              </Typography>
            </Box>
          )} */}
        </Box>

        {/* Segundo Box (Historial de pagos) */}
        <Box
          sx={{
            display: "flex",
            position: "relative",
            flexDirection: "column",
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            padding: 4,
            borderRadius: 5,
            gap: 4,
            width: { xs: "100%", md: "45%" }, // Ancho completo en móvil, 45% en desktop
            boxSizing: "border-box",
            maxHeight: { xs: "400px", md: "500px" }, // Altura máxima en móvil
            overflow: "hidden", // Oculta el overflow
          }}
        >
          <Typography>Historial de pagos</Typography>
          <Box sx={{ overflowY: "auto", maxHeight: "100%" }}>
            <ListPayments listPayment={listPayment.slice().reverse() ?? []} />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default UserAccount;
